<template>
    <!-- 学习页面 -->
    <section class="onload">
        <Header @loadPage="onload"></Header>
        <div class="wrapper">
            <div class="locationM text-left">
                <Breadcrumb>
                    <img class="img" src="../assets/location.png" alt="">
                    当前位置：
                    <BreadcrumbItem to="/">首页</BreadcrumbItem>
                    <BreadcrumbItem>{{titleName}}</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="innerM">
                <div class="title">
                    {{titleName}}
                </div>
                <div class="" v-if="$store.state.isLogin && isAlert == 1 && !showLearningList">
                    <div class="course-card">
                        <div class="course-card__title">
                            <img :src="courseImage" alt="">
                        </div>
                        <div class="course-info">
                            {{ courseTitle }}
                        </div>

                        <div class="course-card__meta-container">
                            <div class="course-card__meta">
                                <span class="course-card__meta-value course-card__meta-value--orange">{{ courseCompletedChapters }}</span>
                                <span class="course-card__meta-item">已完成章节</span>
                            </div>
                            <div class="course-card__meta">
                                <span class="course-card__meta-value">{{ courseTotalChapters }}</span>
                                <span class="course-card__meta-item">总章节数</span>
                            </div>
                            <div class="course-card__meta">
                                <span class="course-card__meta-value">{{ courseTotalLessons }}</span>
                                <span class="course-card__meta-item">总课时数</span>
                            </div>
                        </div>
                        <el-button type="primary" plain @click="showCourseList">开始学习</el-button>
                    </div>
                </div>
                <div class="inner-wrapper" v-if="$store.state.isLogin && isAlert == 1 && showLearningList">
                    <div v-for="(course, index) in courseList" :key="index">
                        <div class="title2">
                            {{ course.title }}
                        </div>
                        <div class="courseM">
                            <div class="col-20 course" v-for="(content, index2) in course.contentList" :key="index2"
                                :data-id="content.contentId" @click="courseClick">
                                <div class="cover inner pointer text-center">
                                    <img :src="content.cover" alt="">
                                    <div class="col-15 progress">
                                        课程目前学习进度 ： {{ content.progress }}%
                                    </div>
                                </div>
                                <div class="name text-left inner pointer">
                                    <div class="col-100 name-text titleTxt">
                                        {{ coursetitle(content.title) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Alert class="alert" v-if="$store.state.isLogin && isAlert == -1" show-icon>
                    您目前还没有需要学习的课程
                    <template slot="desc">You don't have a course to learn at the moment. </template>
                </Alert>
                <Alert class="alert" type="error" v-if="!$store.state.isLogin" show-icon>
                    您需要登录后才能查看该内容
                    <span slot="desc">You need to be logged in to view this content.</span>
                </Alert>
            </div>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
    import Header from './components/Header'
    import Footer from './components/Footer'
    export default {
        name: "Learn",
        data() {
            return {
                isAlert: '',  //-1代表无课程，1代表有课程
                courseList: [],
                subjectCode: 0,
                subjectName: '',
                titleName: '',
                type:1, //1代表行业培训，2代表职称继教
                showLearningList: false,

                courseCompletedChapters: 0,// 已学章节
                courseImage: '',// 继教过渡页图片
                courseTitle: '',
                courseTotalChapters: 0,// 总章节
                courseTotalLessons: 0,// 总课时
            }
        },
        mounted() {
            var that = this;
            that.onload();
            if (this.subjectCode == 1 || this.subjectCode == 2 || this.subjectCode == 3) {
                this.setTab();
            } else {
                this.$store.state.tab = '职称继教'
            }
        },
        watch: {
            '$route': {
                handler(newRoute, oldRoute) {
                    if (!oldRoute || newRoute.query.subjectCode !== oldRoute.query.subjectCode) {
                        // 初始化

                        
                        this.onload();
                        if (this.subjectCode == 1 || this.subjectCode == 2 || this.subjectCode == 3) {
                            this.setTab();
                        } else {
                            this.$store.state.tab = '职称继教'
                        }
                    }
                },
                deep: true,
                immediate: true
            },
        },
        methods: {
            onload() {
                this.initData()
                console.log(this.$route.query.subjectCode)
                this.subjectCode = this.$route.query.subjectCode;

                // if (this.subjectCode == 1) {
                //     this.subjectName = '工程经理';
                // } else if (this.subjectCode == 2) {
                //     this.subjectName = '能力提高班';
                // } else if (this.subjectCode == 3) {
                //     this.subjectName = '运维工程师';
                // } else {
                //     this.subjectName = '行业培训';
                // }

                if (this.subjectCode == 1 || this.subjectCode == 2 || this.subjectCode == 3) {
                    this.titleName = '行业培训';
                    this.type=2
                } else {
                    this.titleName = '职称继教';
                    this.type=1
                }

                this.updateShowLearningList()


                //初始化
                var that = this;
                var token = that.$cookie.get('xjaf-token');
                var username = that.$cookie.get('xjaf-user');
                if (token != null && username != null) {
                    that.httprequest();
                    that.getCourseData();
                    console.log(666);
                    that.$http({
                        url: that.webhost + 'user/checkStandard',
                        method: 'GET'
                    }).then(({ data }) => {
                        console.log(data, 9999)
                        if (data && data.code === 0 && data.data != 0) {
                            that.$store.commit('setAlertExam');
                            that.$store.commit('setSubjectCode', data.data);
                        }
                    })
                    //恢复滚动
                    $('body').removeAttr('style');
                } else {
                    this.$store.commit('login');
                }
            },
            httprequest() {
                var that = this;
                that.$store.state.tab = 1;
                var modelData = {
                    "page": "1",
                    "size": "10",

                };
                this.$http({
                    url: that.webhost + 'course/courseListWeb?type='+this.type,
                    method: 'POST',
                    data: modelData
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        var tmp = data.data;
                        if (tmp.length > 0) {
                            that.isAlert = 1;
                            that.courseList = tmp;
                        } else {
                            that.isAlert = -1;
                        }
                    } else {
                        that.$Message.error(data.msg)
                        that.isAlert = -1;
                    }
                })
            },
            courseClick(e) {
                this.$router.push(`/Course/${e.currentTarget.dataset.id}?subjectCode=${this.subjectCode}&from=IndustryTraining`);
            },
            initData() {
                this.isAlert = ''
                this.courseList = []
                this.subjectCode = 0
                this.subjectName = ''
                this.titleName = ''
                this.type = 1
                this.showLearningList = false
            },
            updateShowLearningList() {
                this.showLearningList = this.subjectCode == 1 || this.subjectCode == 2 || this.subjectCode == 3
                    || this.$route.query.showList === 'true'
            },
            showCourseList() {
                this.showLearningList = true
            },
            getCourseData() {
                var that = this;
                this.$http({
                    url: that.webhost + 'guide/getMyJjgd',
                    method: 'GET'
                }).then(({data}) => {
                    if (data && data.code === 0) {
                        that.courseCompletedChapters = data.data.completedChapters || 0;// 已学章节
                        that.courseImage = data.data.imgUrl || '';// 继教过渡页图片
                        that.courseTitle = data.data.title || '';// 继教过渡页标题
                        that.courseTotalChapters = data.data.totalChapters || 0;// 继教过渡页总章节
                        that.courseTotalLessons = data.data.totalLessons || 0;// 继教过渡页总课时
                    }
                })
            },
        },
        components: {
            Header,
            Footer
        }
    }
</script>

<style scoped>
    .wrapper {
        width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 70px;
        font-family: "PingFang SC";
    }

    .title {
        text-align: left;
        font-size: 25px;
        line-height: 72px;
        color: #000;
        border-bottom: solid 2px #ccc;
    }

    .title2 {
        text-align: left;
        font-size: 21px;
        line-height: 70px;
        color: #000;
    }

    .locationM {
        height: 50px;
        line-height: 50px;
    }

    .locationM .ivu-breadcrumb {
        font-size: 15px;
        color: #000;
    }

    .locationM img {
        width: 23px;
        height: 22px;
        margin-right: 5px;
        position: relative;
        top: 3px;
    }

    .innerM {
        margin-top: 20px;
        min-height: 500px;
    }

    .courseM {
        width: 100%;
        text-align: left;
    }

    /* 卡片容器 */
    .course-card {
        background: #f6f6f6;
        border-radius: 8px;
        padding: 20px 40px;
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        gap: 24px;
    }

    /* 课程标题 */
    .course-card__title {
        width: 200px;
        height: 100px;
        /* background-color: #fff; */
        border-radius: 10px;
        overflow: hidden;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        user-select: none;
        transition: box-shadow 0.2s ease, transform 0.2s ease;

        /* font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 1.4;
        margin-bottom: 12px;
        word-break: break-word; */
    }

    .course-card__title:hover {
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
        transform: translateY(-1px);
    }

    .course-card__title img {
        width: 100%;
        height: 100%;
    }

    .course-info {
        text-align: start;
        font-size: 14px;
    }

    .course-card__meta-container {
        display: flex;
        align-items: center;
        gap: 50px;
        height: 80px;
        background-color: #fff;
        border-radius: 8px;
        padding: 0 30px;
    }

    .course-card__meta-value {
        color: #1890ff;
        font-size: 20px;
        font-weight: 600;
    }

    .course-card__meta-value--orange {
        color: #ff6600;
    }

    /* 元信息区域（总课时/课程数） */
    .course-card__meta {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .course-card__meta-item {
        display: inline-block;
    }

    /* 圆 */
    .progress-circle {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 4px solid #b8b8b8;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 12px;
        color: #1890ff;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }

    .progress-circle span {
        line-height: 1.3;
    }

    .course {
        display: inline-flex;
        flex-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        width: 20%;
        margin-bottom: 25px;
        padding-top: 7px;
    }

    .course:hover {
        border-color: #ddd;
        box-shadow: 1px 1px 2px 1px #ddd;
    }

    .course .inner {
        width: 95%;
        margin: auto;
    }

    .course .cover {
        position: relative;
    }

    .course .cover img {
        width: 95%;
        height: 128px;
    }

    .course .inner .progress {
        position: absolute;
        width: 95%;
        line-height: 25px;
        left: 2.5%;
        bottom: 5px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.79);
    }

    .course .btn {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
    }

    .course .name {
        overflow: hidden;
        font-size: 15px;
        color: #000;
        padding: 5px 0 5px 2px;
        line-height: 30px;
    }

    .course .name .name-text {
        /*float: left;*/
    }

    .progress {
        float: right;
    }

    /* .titleTxt{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    } */
</style>


// WEBPACK FOOTER //
// src/views/IndustryTraining.vue